

import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

export interface Locale {
    lang: string;
    data: any;
}

const LOCALIZATION_LOCAL_STORAGE_KEY = 'language';

@Injectable({
    providedIn: 'root',
})
export class TranslationService {
    changeTranslation(arg0: string) {
        throw new Error('Method not implemented.');
    }
    // Private properties
    private langIds: any = [];

    constructor(private translate: TranslateService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private meta: Meta) {
        this.translate.addLangs(['en', 'es','pt']);
        if (isPlatformBrowser(this.platformId)) {
            this.translate.setDefaultLang(translate.getBrowserLang());
        }
    }

    loadTranslations(...args: Locale[]): void {
        const locales = [...args];

        locales.forEach((locale) => {
            this.translate.setTranslation(locale.lang, locale.data, true);
            this.langIds.push(locale.lang);
        });

        this.translate.addLangs(this.langIds);
        if (isPlatformBrowser(this.platformId)) {
            this.translate.setDefaultLang(this.getSelectedLanguage());
        }
    }

    setLanguage(lang: any) {
        if (isPlatformBrowser(this.platformId)) {
            if (lang) {
                this.translate.use(this.translate.getDefaultLang());
                this.translate.use(lang);
                localStorage.setItem(LOCALIZATION_LOCAL_STORAGE_KEY, lang);
            }
        }
        /*this.translateKeyLang('HOME.META_DESCRIPTION', lang)
        .then((resp: any) => {
          console.log('🚀 ~ AppComponent ~ .then ~ resp:', resp);
          this.meta.updateTag({ name: 'description', content: resp });
          this.meta.updateTag({ property: 'og:description', content: resp });
          console.log('actualoizadoooo======');
        });*/
    }

    getSelectedLanguage(): any {
        if (!localStorage.getItem(LOCALIZATION_LOCAL_STORAGE_KEY)) this.setLanguage(this.translate.getDefaultLang());

        return localStorage.getItem(LOCALIZATION_LOCAL_STORAGE_KEY)
    }

    translateKeyLang(key_name: string, lang: any) {
        return new Promise((resolve) => {
            const currentLang = this.translate.currentLang; // Almacena el idioma actual
            this.translate.use(lang); // Cambia temporalmente al idioma deseado para obtener la traducción
            const translatedText = this.translate.instant(key_name); // Obtiene la traducción
            // Restablece el idioma al valor original después de obtener la traducción
            this.translate.use(currentLang);
            resolve(translatedText);
        });
    }


}
